import React from 'react';
import { MDBFooter,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBBtn } from 'mdb-react-ui-kit';
import './css components/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faYoutube, faLinkedinIn} from '@fortawesome/free-brands-svg-icons';
import { useEffect } from 'react';
import WOW from 'wowjs';

function Footer () {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false
    });
    wow.init();
  }, []);
  return (
    <MDBFooter className='text-center footer' color='white'>
    <MDBContainer className='p-4'>
      <section className='mb-4'>
        <MDBBtn outline color="light" floating className='m-1' href='https://www.facebook.com/megateam.mu18' target='_blank' role='button'>
        <FontAwesomeIcon icon={faFacebook} />
        </MDBBtn>
        <MDBBtn outline color="light" floating className='m-1' href='https://www.instagram.com/megateammu/?igshid=MzRlODBiNWFlZA%3D%3D' target='_blank' role='button'>
        <FontAwesomeIcon icon={faInstagram} />
        </MDBBtn>
        <MDBBtn outline color="light" floating className='m-1' href='https://www.youtube.com/@MEGATeamMU' target='_blank' role='button'>
        <FontAwesomeIcon icon={faYoutube} />
        </MDBBtn>
        <MDBBtn outline color="light" floating className='m-1' href='https://www.linkedin.com/company/mega-team-mu/' target='_blank' role='button'>
        <FontAwesomeIcon icon={faLinkedinIn} />
        </MDBBtn>
      </section>

      <section className='mb-4 p'>
        <p className=' wow slideInLeft' data-wow-duration="2s" data-wow-delay=".4s"> 
        By becoming a part of our team, you'll have the chance to unleash your potential, expand your horizons, and work alongside like-minded peers who share your aspirations.
        </p>
      </section>

      {/* <section className=''>
        <MDBRow>
          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>Links</h5>

            <ul className='list-unstyled mb-0'>
              <li>
                <a href='#!' className='text-white'>
                  Link 1
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 2
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 3
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 4
                </a>
              </li>
            </ul>
          </MDBCol>

          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>Links</h5>

            <ul className='list-unstyled mb-0'>
              <li>
                <a href='#!' className='text-white'>
                  Link 1
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 2
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 3
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 4
                </a>
              </li>
            </ul>
          </MDBCol>

          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>Links</h5>

            <ul className='list-unstyled mb-0'>
              <li>
                <a href='#!' className='text-white'>
                  Link 1
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 2
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 3
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 4
                </a>
              </li>
            </ul>
          </MDBCol>

          <MDBCol lg='3' md='6' className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>Links</h5>

            <ul className='list-unstyled mb-0'>
              <li>
                <a href='#!' className='text-white'>
                  Link 1
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 2
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 3
                </a>
              </li>
              <li>
                <a href='#!' className='text-white'>
                  Link 4
                </a>
              </li>
            </ul>
          </MDBCol>
        </MDBRow>
      </section> */}
    </MDBContainer>

    <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
      © 2023 Copyright: 
        <a className='text-white' href='https://www.facebook.com/megateam.mu18' target="_blank" id='mega-word'>
        MEGA TEAM
      </a>
    </div>
  </MDBFooter>
  );
}
export default Footer;